var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchInputIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84458 12.9713C5.15271 12.2649 4.68344 11.3709 4.49498 10.4001C4.30497 9.42671 4.40254 8.41903 4.77578 7.50014C5.14584 6.58641 5.77762 5.8024 6.59178 5.24654C8.24367 4.11834 10.4183 4.11834 12.0702 5.24654C12.8844 5.8024 13.5162 6.58641 13.8862 7.50014C14.2594 8.41903 14.357 9.42671 14.167 10.4001C13.9786 11.3709 13.5093 12.2649 12.8174 12.9713C11.9011 13.9116 10.6439 14.4419 9.33095 14.4419C8.01807 14.4419 6.76086 13.9116 5.84458 12.9713Z",
    stroke: "#B8B8B8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33565 6.16255C9.00613 6.19746 8.76733 6.4929 8.80221 6.82243C8.83717 7.15196 9.13261 7.39078 9.46213 7.35587L9.33565 6.16255ZM10.8168 8.15392C10.946 8.45909 11.2981 8.60173 11.6033 8.47253C11.9084 8.34335 12.051 7.99125 11.9218 7.6861L10.8168 8.15392ZM13.3132 12.4697C13.0787 12.2357 12.6988 12.236 12.4647 12.4705C12.2305 12.705 12.2309 13.0849 12.4654 13.319L13.3132 12.4697ZM15.1758 16.0246C15.4104 16.2588 15.7902 16.2585 16.0244 16.0239C16.2585 15.7893 16.2581 15.4095 16.0236 15.1753L15.1758 16.0246ZM9.46213 7.35587C10.0401 7.29462 10.5902 7.61866 10.8168 8.15392L11.9218 7.6861C11.4893 6.66425 10.4392 6.04562 9.33565 6.16255L9.46213 7.35587ZM12.4654 13.319L15.1758 16.0246L16.0236 15.1753L13.3132 12.4697L12.4654 13.319Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInputIcon);
export default __webpack_public_path__ + "static/media/search-input-icon.533753ffc57b9968c0f3e745e50342a4.svg";
export { ForwardRef as ReactComponent };